import React from 'react';
import {Dialog} from 'material-ui';
import {DialogTitle} from 'material-ui';
import {DialogContent} from 'material-ui';
import './GoToNextRoundDialog.css';
import MyButton from '../components/MyButton';
import {colors} from '../styles/colors';

function GoToNextRoundDialog({isOpen, onClose, title, ctaText, onCtaPress}) {
	return (
		<Dialog
			className='go-to-next-round-dialog'
			open={!!isOpen}
			onClose={onClose}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			style={{borderRadius: 50}}
			actionsContainerClassName={{borderRadius: 50}}
			bodyStyle={{borderRadius: 50}}
		>
			<DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
			<DialogContent>
				<img style={{width: '100%'}} src={require('./check.png')} />
				<MyButton
					size='large'
					style={{
						background: colors.primaryColor,
						color: '#fff',
						textAlign: 'center',
					}}
					onPressButton={onCtaPress}
					title={ctaText}
				/>
			</DialogContent>
		</Dialog>
	);
}
export default GoToNextRoundDialog;



// WEBPACK FOOTER //
// ./src/workout/GoToNextRoundDialog.js